<div [ngClass]="_containerClass">
  <ng-content />
</div>
